import React from 'react';
import { cn } from '../../lib/utils';

export interface AvatarProps extends React.HTMLAttributes<HTMLDivElement> {
  userId: string;
  initials: string;
  imageUrl?: string;
  size?: 'sm' | 'md' | 'lg';
}

export const Avatar: React.FC<AvatarProps> = ({ 
  userId, 
  initials, 
  imageUrl,
  size = 'md', 
  className,
  ...props 
}) => {
  const [imageError, setImageError] = React.useState(false);

  // Section 8.5: Background color rotates through based on userId hash
  const colors = [
    'bg-brand-secondary',
    'bg-teal-600',
    'bg-purple-600',
    'bg-amber-600',
    'bg-brand-primary',
  ];
  
  const colorIndex = (userId || '').split('').reduce((acc, char) => acc + char.charCodeAt(0), 0) % colors.length;
  const bgColor = colors[colorIndex];

  const sizes = {
    sm: 'w-7 h-7 text-xs',
    md: 'w-9 h-9 text-sm',
    lg: 'w-11 h-11 text-base',
  };

  const showImage = Boolean(imageUrl && !imageError);

  return (
    <div
      className={cn(
        'rounded-full flex items-center justify-center text-white font-medium flex-shrink-0 overflow-hidden',
        bgColor,
        sizes[size],
        className
      )}
      {...props}
    >
      {showImage ? (
        <img 
          src={imageUrl} 
          alt={initials} 
          className="w-full h-full object-cover"
          referrerPolicy="no-referrer"
          onError={() => setImageError(true)}
        />
      ) : (
        (initials || '').toUpperCase()
      )}
    </div>
  );
};
